/* V4 product page behaviour.

   Replaces the selection and basket-preview parts of
   serious-readers-brand-2026/public/product.js. The prototype held its own
   price table and opened a dialog saying no order had been placed. This reads
   the real variant list rendered by v4-product.liquid, posts to /cart/add.js
   and hands off to Dawn's cart drawer.

   The gallery keeps the prototype's five curated shots. Selecting a finish or
   base swaps the "Your light" shot using the packshot map from the section. */
(function () {
  function parseData(root) {
    // The JSON sits alongside the section inside the same shopify-section wrapper.
    var scope = root.closest('.shopify-section') || root.parentNode || document;
    var node = scope.querySelector('[data-v4-variants]') || document.querySelector('[data-v4-variants]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function wire(root) {
    if (root.dataset.v4Wired === 'true') return;
    root.dataset.v4Wired = 'true';

    var data = parseData(root);
    if (!data) return;

    var finishIndex = parseInt(root.dataset.finishIndex, 10);
    var baseIndex = parseInt(root.dataset.baseIndex, 10);
    var form = root.querySelector('#v4-product-form');
    var idField = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('#p-price');
    var wasEl = root.querySelector('#p-was');
    var selectionEl = root.querySelector('#p-selection');
    var finishNameEl = root.querySelector('#p-finish-name');
    var baseHintEl = root.querySelector('#p-base-hint');
    var finishThumb = root.querySelector('#p-finish-thumb');
    var buyButton = root.querySelector('[data-p-buy]');
    // The sticky mobile bar is its own section, so it sits outside this root.
    var mobilePrice = document.getElementById('p-mobile-price');
    var buyLabel = root.querySelector('[data-p-buy-label]');
    var errorEl = root.querySelector('[data-p-error]');

    var selected = {
      finish: finishNameEl ? finishNameEl.textContent.trim() : null,
      base: null,
    };
    var pressedBase = root.querySelector('[data-p-base][aria-pressed="true"]');
    if (pressedBase) selected.base = pressedBase.dataset.pBase;
    // Any other option (the HD Pro's "Mains or Cordless"), keyed by its option index (23 Sep 2026).
    selected.others = {};
    root.querySelectorAll('[data-p-option][aria-pressed="true"]').forEach(function (button) {
      selected.others[button.dataset.pOption] = button.dataset.pValue;
    });

    // Button wording comes from the section settings and the locale, not from
    // this file, so an edit in the theme editor survives a variant change.
    function label(key, fallback) {
      var attr = { add: 'labelAdd', soldOut: 'labelSoldOut', unavailable: 'labelUnavailable' }[key];
      return (buyButton && buyButton.dataset[attr]) || fallback;
    }

    // One place decides whether Add to basket can be pressed (audit, 25 Sep 2026): never while an add is on its
    // way, because a finish or base changed mid-request used to re-enable it and a second light went in, and never
    // for a choice that is sold out, including a page brought back by the Back button.
    var adding = false;
    function syncBuy(variant, keepLabel) {
      if (!buyButton) return;
      buyButton.disabled = adding || !variant || !variant.available;
      if (!buyLabel || adding || keepLabel) return;
      buyLabel.textContent = !variant ? label('unavailable', 'Unavailable')
        : variant.available ? label('add', 'Add to basket') : label('soldOut', 'Sold out');
    }

    // The finish thumbnail stays thumbnail-sized when the packshot behind it changes.
    function thumbSrc(url) {
      if (!url || !/\.(webp|jpe?g|png)(\?|$)/i.test(url)) return url;
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1300');
      return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=300';
    }

    function findVariant() {
      return data.variants.find(function (variant) {
        var finishOk = isNaN(finishIndex) || variant.options[finishIndex] === selected.finish;
        var baseOk = isNaN(baseIndex) || variant.options[baseIndex] === selected.base;
        var othersOk = Object.keys(selected.others).every(function (i) {
          return variant.options[parseInt(i, 10)] === selected.others[i];
        });
        return finishOk && baseOk && othersOk;
      });
    }

    function packshotKey() {
      return (selected.base || '') + '|' + (selected.finish || '');
    }

    // The light's own cut-out in exactly the finish and base on screen, or '' when this page has none for it.
    function lightShot() {
      try { return (data.packshots && data.packshots[packshotKey()]) || ''; } catch (e) { return ''; }
    }

    // A choice that cannot be bought with the other choices on screen is greyed and says "Sold out" under its name
    // before it is pressed (22 Oct 2026). The page draws the first state (snippets/v4-option-out.liquid); this keeps it
    // right as the choices change. It can still be pressed: the buy button then says Sold out, as before.
    function inStockWith(index, value) {
      return data.variants.some(function (variant) {
        if (!variant.available || variant.options[index] !== value) return false;
        for (var i = 0; i < variant.options.length; i += 1) {
          if (i === index) continue;
          var want = i === finishIndex ? selected.finish : i === baseIndex ? selected.base : selected.others[i];
          if (want != null && variant.options[i] !== want) return false;
        }
        return true;
      });
    }
    function markOut() {
      root.querySelectorAll('[data-p-finish], [data-p-base], [data-p-option]').forEach(function (button) {
        var index = button.hasAttribute('data-p-finish') ? finishIndex : button.hasAttribute('data-p-base') ? baseIndex : parseInt(button.dataset.pOption, 10);
        var value = button.hasAttribute('data-p-finish') ? button.dataset.pFinish : button.hasAttribute('data-p-base') ? button.dataset.pBase : button.dataset.pValue;
        if (isNaN(index) || value == null) return;
        var out = !inStockWith(index, value);
        button.classList.toggle('is-out', out);
        var note = button.querySelector('.p-out-note');
        if (note) note.hidden = !out;
      });
    }

    function render() {
      markOut();
      var variant = findVariant();

      if (finishNameEl && selected.finish) finishNameEl.textContent = selected.finish;

      if (baseHintEl && data.baseHints && selected.base && data.baseHints[selected.base]) {
        baseHintEl.textContent = data.baseHints[selected.base];
      }

      var shot = data.packshots ? data.packshots[packshotKey()] : null;
      if (shot && finishThumb) {
        var smallShot = thumbSrc(shot);
        if (finishThumb.getAttribute('src') !== smallShot) finishThumb.src = smallShot;
        var thumbButton = finishThumb.closest('[data-p-gallery="finish"]');
        if (thumbButton) {
          thumbButton.dataset.pFull = shot;
          // Show the shopper what they just chose: flick the gallery to the
          // cutout in that finish and base. showShot fades it in and marks the
          // stage as a cutout so it is shown whole. On first load the src is
          // the same, so nothing moves.
          if (userChange && typeof showShot === 'function' && Array.isArray(thumbs)) {
            var finishIndex = thumbs.indexOf(thumbButton);
            if (finishIndex >= 0) showShot(finishIndex);
          } else if (thumbButton.getAttribute('aria-pressed') === 'true') {
            var hero = root.querySelector('#p-hero');
            if (hero) { hero.removeAttribute('srcset'); hero.removeAttribute('sizes'); hero.src = shot; }
          }
        }
      }

      // The base chooser follows the buy box: the chosen base is marked, and each card shows the
      // light in the chosen finish (Josh, 23 Sep: the popup shows the lights on those bases).
      var sizesPanel = root.querySelector('[data-p-sizes]');
      if (sizesPanel) {
        sizesPanel.querySelectorAll('[data-p-sizes-card]').forEach(function (card) {
          card.classList.toggle('is-selected', card.dataset.pSizesCard === selected.base);
          var img = card.querySelector('[data-p-sizes-shot]');
          var src = data.packshots ? data.packshots[card.dataset.pSizesCard + '|' + (selected.finish || '')] : null;
          if (img && src && img.getAttribute('src') !== src) img.src = src;
        });
      }

      if (!variant) {
        syncBuy(null);
        // A combination this light is not made in: the stock line says it cannot be bought rather than keep the last
        // choice's delivery line (final audit, 25 Sep 2026).
        var gone = document.getElementById('p-stock');
        if (gone && gone.dataset.pStockOut) gone.textContent = gone.dataset.pStockOut;
        return;
      }

      if (idField) idField.value = variant.id;
      // Read out to screen readers: nothing for a light with no choices, and ", sold out" on a sold-out choice.
      if (selectionEl) selectionEl.textContent = variant.title === 'Default Title' ? '' : variant.title + (variant.available ? '' : ', sold out');
      // The final close and anything else that echoes the choice (Product Page
      // Plan: "persistent selected-variant state as people explore").
      document.querySelectorAll('[data-p-echo-selection]').forEach(function (el) { el.textContent = variant.title; });
      document.querySelectorAll('[data-p-echo-price]').forEach(function (el) { el.textContent = variant.priceFormatted; });

      // The offer engine rewrites the price into a struck-through offer block and
      // marks the element so it never does it twice. Writing plain text back over
      // that would leave the marker in place and the offer gone for good, so the
      // marker is cleared and the engine's observer redoes the swap.
      if (priceEl) {
        priceEl.removeAttribute('data-sr-p');
        priceEl.removeAttribute('data-sr-v');
        priceEl.textContent = variant.priceFormatted;
      }

      if (wasEl) {
        wasEl.removeAttribute('data-sr-p');
        wasEl.removeAttribute('data-sr-v');
        if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
          wasEl.textContent = variant.compareAtFormatted;
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }

      if (mobilePrice) {
        // Same reason as the main price: let the offer engine redo its swap.
        mobilePrice.removeAttribute('data-sr-p');
        mobilePrice.removeAttribute('data-sr-v');
        mobilePrice.textContent = variant.priceFormatted;
      }

      syncBuy(variant);

      // The stock line follows the choice. In the UK the offer display redraws it straight after (sr:variant below);
      // elsewhere nothing else does, so a sold-out finish used to keep saying In stock (audit, 25 Sep 2026).
      var stockEl = document.getElementById('p-stock');
      if (stockEl && stockEl.dataset.pStockIn) {
        stockEl.textContent = variant.available ? stockEl.dataset.pStockIn : stockEl.dataset.pStockOut;
      }

      // Keep the address bar on the chosen variant, so a shared link reopens it.
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // The offer display (snippets/v4-offer-display.liquid) repaints the price, the lines under it and the delivery
      // line for this variant. Finish and base are buttons, so no change event fires by itself.
      document.dispatchEvent(new CustomEvent('sr:variant', { detail: { variant: String(variant.id) } }));
    }

    // True only while a shopper's own choice is being applied. The initial
    // render on load leaves the room photograph on the stage (Josh, 16 Sep).
    var userChange = false;
    function choose(kind, value, group) {
      selected[kind] = value;
      group.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset['p' + kind[0].toUpperCase() + kind.slice(1)] === value));
      });
      userChange = true;
      // A new choice clears an old add-to-basket message, which was about the previous choice (launch audit, 25 Sep).
      if (errorEl) errorEl.hidden = true;
      try { render(); } finally { userChange = false; }
    }

    var finishButtons = Array.prototype.slice.call(root.querySelectorAll('[data-p-finish]'));
    finishButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        choose('finish', button.dataset.pFinish, finishButtons);
      });
    });

    var baseButtons = Array.prototype.slice.call(root.querySelectorAll('[data-p-base]'));
    baseButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        choose('base', button.dataset.pBase, baseButtons);
      });
    });

    // Every other option's buttons (the HD Pro's "Mains or Cordless"): press the one chosen in its own group,
    // name it in the legend, then pick the variant again.
    var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-p-option]'));
    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = button.dataset.pOption;
        selected.others[index] = button.dataset.pValue;
        optionButtons.forEach(function (other) {
          if (other.dataset.pOption === index) other.setAttribute('aria-pressed', String(other === button));
        });
        var nameEl = root.querySelector('[data-p-option-name="' + index + '"]');
        if (nameEl) nameEl.textContent = button.dataset.pValue;
        userChange = true;
        // As in choose(): a new choice clears an old add-to-basket message (launch audit recheck, 25 Sep 2026).
        if (errorEl) errorEl.hidden = true;
        try { render(); } finally { userChange = false; }
      });
    });

    // The choice is live, so the safety net in v4-product.liquid (which works these buttons if this file never runs)
    // stands aside from here (purchase audit, 25 Sep 2026).
    root.dataset.v4Choice = 'ready';

    // ------------------------------------------------------------- gallery
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-p-gallery]'));
    var hero = root.querySelector('#p-hero');
    var caption = root.querySelector('#p-caption');
    var count = root.querySelector('#p-gallery-count');

    // INSTANT PHOTOGRAPHS (Josh, 25 Sep 2026: "It needs to be instant"). Each photograph is fetched at the stage's
    // own size (Shopify's CDN resizes it: the same 480/800/1200 steps the first photo's srcset uses), and all of them
    // load one after another in the background once the page has finished, or at once when a finger or pointer
    // lands on a thumbnail, so a click shows a picture that is already in the browser.
    var STAGE_WIDTHS = [480, 800, 1200];
    function stageSrc(url) {
      if (!url) return url;
      var need = Math.round(((hero && hero.getBoundingClientRect().width) || 600) * (window.devicePixelRatio || 1));
      var pick = 0;
      for (var i = 0; i < STAGE_WIDTHS.length; i++) { if (STAGE_WIDTHS[i] >= need) { pick = STAGE_WIDTHS[i]; break; } }
      if (/[?&]width=\d+/.test(url)) return pick ? url.replace(/([?&]width=)\d+/, '$1' + pick) : url;
      if (!pick || !/\.(webp|jpe?g|png)(\?|$)/i.test(url)) return url;
      return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + pick;
    }
    var warmed = {};
    function warm(url, done) {
      if (!url || warmed[url]) { if (done) done(); return; }
      var im = new Image();
      warmed[url] = im;
      im.addEventListener('load', function () { if (done) done(); });
      im.addEventListener('error', function () { if (done) done(); });
      im.src = url;
    }
    (function warmGallery() {
      thumbs.forEach(function (b) {
        ['pointerenter', 'touchstart', 'focus'].forEach(function (type) {
          b.addEventListener(type, function () { warm(stageSrc(b.dataset.pFull)); }, { passive: true });
        });
      });
      var start = function () {
        // On a data saver or a slow line (2G or 3G) the gallery photos load only when asked for, so these background
        // downloads never share a weak line with Add to basket (slow-connection check, 8 Oct 2026). Safari has no
        // navigator.connection and keeps the warm-up.
        var link = navigator.connection;
        if (link && (link.saveData || /(^|-)(2g|3g)$/.test(link.effectiveType || ''))) return;
        var queue = thumbs.map(function (b) { return stageSrc(b.dataset.pFull); });
        if (data.packshots) Object.keys(data.packshots).forEach(function (k) { queue.push(stageSrc(data.packshots[k])); });
        (function nextOne() {
          if (!queue.length) return;
          warm(queue.shift(), nextOne);
        })();
      };
      var idle = window.requestIdleCallback || function (f) { return window.setTimeout(f, 300); };
      if (document.readyState === 'complete') idle(start);
      else window.addEventListener('load', function () { idle(start); });
    })();

    (function markInitialShot() {
      var pressed = thumbs.find ? thumbs.find(function (b) { return b.getAttribute('aria-pressed') === 'true'; }) : null;
      if (hero && pressed) hero.dataset.pShot = pressed.dataset.pGallery || '';
    })();

    // The photograph actually on the stage, which is not always the thumbnail last pressed: a failed load goes back to
    // this one, not to a choice that never arrived (audit, 25 Sep 2026: two quick choices and a failure left the caption
    // describing a photo that was not showing).
    var shownIndex = currentShot();

    function showShot(index) {
      var button = thumbs[index];
      if (!button || !hero) return;
      // Measure the stage before anything on the page changes. Reading its size after the thumbnails' aria-pressed had
      // changed made the browser lay the whole page out again inside the tap (speed audit, 20 Oct 2026: about 120 ms of
      // a 208 ms tap on a mid-range phone). The thumbnails never change the stage's size, so the answer is the same.
      var nextSrc = stageSrc(button.dataset.pFull) || button.querySelector('img').src;
      thumbs.forEach(function (other, i) {
        other.setAttribute('aria-pressed', String(i === index));
      });
      // Tell the stage which shot it is showing, so a product cutout is shown
      // whole (contain) and a room photograph fills the frame (cover). Before
      // this every shot was cropped to fill, which cut the head off the light.
      var nextShot = button.dataset.pGallery || '';
      var nextAbs = nextSrc;
      try { nextAbs = new URL(nextSrc, window.location.href).href; } catch (e) { /* older browsers: compare as written */ }
      if (nextAbs !== hero.src) {
        // Cross-fade (Josh, 16 Sep): the photograph on screen is kept as a layer
        // over the stage while the next one loads beneath it, then the layer
        // fades away. Nothing ever blinks to blank. .p-gallery-previous was
        // reserved for this in the design's stylesheet and never used.
        var stage = hero.parentNode;
        var previous = stage.querySelector('.p-gallery-previous');
        if (previous) previous.remove();
        previous = hero.cloneNode(false);
        previous.removeAttribute('id');
        previous.className = 'p-gallery-previous';
        previous.setAttribute('aria-hidden', 'true');
        stage.insertBefore(previous, hero.nextSibling);
        var reveal = function (src) {
          if (hero.dataset.pending !== src) return;
          delete hero.dataset.pending;
          shownIndex = index;
          // The fit changes only now, with the new photograph, so neither the
          // outgoing layer nor the stage ever resizes while the old shot shows.
          hero.dataset.pShot = nextShot;
          // The first photograph arrives with a srcset (phone-sized copies), and a srcset
          // outranks src, so without this the caption changed but the photograph did not.
          hero.removeAttribute('srcset');
          hero.removeAttribute('sizes');
          hero.src = src;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              previous.classList.add('is-leaving');
              window.setTimeout(function () { if (previous.parentNode) previous.remove(); }, 260);
            });
          });
        };
        // A photograph that fails to load never replaces the one on screen (audit, 25 Sep 2026: a failed request
        // left a broken image). The file as uploaded is tried once, then the choice goes back to the photo showing.
        var load = function (src, fallback) {
          hero.dataset.pending = src;
          var pending = new Image();
          pending.onload = function () { reveal(src); };
          pending.onerror = function () {
            if (hero.dataset.pending !== src) return;
            if (fallback && fallback !== src) { load(fallback, null); return; }
            delete hero.dataset.pending;
            if (previous.parentNode) previous.remove();
            thumbs.forEach(function (other, i) { other.setAttribute('aria-pressed', String(i === shownIndex)); });
            var back = thumbs[shownIndex];
            if (caption && back && back.dataset.pCaption) caption.textContent = back.dataset.pCaption;
            if (count) count.textContent = shownIndex + 1 + ' / ' + thumbs.length;
          };
          pending.src = src;
          if (pending.complete && pending.naturalWidth) reveal(src);
        };
        load(nextSrc, button.dataset.pFull);
      } else {
        // Back on the photograph already showing: a slower one still on its way must not land after it.
        delete hero.dataset.pending;
        var left = hero.parentNode.querySelector('.p-gallery-previous');
        if (left) left.remove();
        hero.dataset.pShot = nextShot;
        shownIndex = index;
      }
      if (caption && button.dataset.pCaption) caption.textContent = button.dataset.pCaption;
      if (count) count.textContent = index + 1 + ' / ' + thumbs.length;
    }

    thumbs.forEach(function (button, index) {
      button.addEventListener('click', function () {
        showShot(index);
      });
    });

    // The big photo swipes on a phone or iPad, as people expect (full audit round 2, 8 Oct 2026: it only moved from the
    // thumbnails and the arrows). A sideways swipe of 40px or more, clearly more sideways than up or down, moves one
    // photo; a tap opens the enlarged photograph (wired below), but not straight after a swipe.
    var swipeX = null, swipeY = 0, swiped = false;
    var stageEl = hero && hero.parentNode;
    if (stageEl && thumbs.length > 1) {
      stageEl.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') return;
        swipeX = event.clientX; swipeY = event.clientY; swiped = false;
      });
      stageEl.addEventListener('pointerup', function (event) {
        if (swipeX === null) return;
        var dx = event.clientX - swipeX, dy = event.clientY - swipeY;
        swipeX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          swiped = true;
          showShot((currentShot() + (dx < 0 ? 1 : thumbs.length - 1)) % thumbs.length);
        }
      });
      stageEl.addEventListener('pointercancel', function () { swipeX = null; });
    }

    // Enlarge: the current photograph in a dialog, with the gallery's own
    // previous/next and Escape to close. The button was in the markup with
    // nothing wired to it.
    // -------------------------------- the bar steps back in the story
    // Josh, 16 Sep: the sticky bar was sitting on top of the cinematic sections.
    // While one of them fills the view it drops to a single compact line.
    (function quietBar() {
      var bar = document.querySelector('.p-mobile-buy');
      // only the big visual chapters. The trial, the fit table and the questions
      // are buying moments, so the bar stays whole there.
      var chapters = document.querySelectorAll('.p-why, #demo, #scale');
      if (!bar || !chapters.length || !('IntersectionObserver' in window)) return;
      var inside = 0;
      var watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inside += entry.isIntersecting ? 1 : -1;
        });
        if (inside < 0) inside = 0;
        bar.classList.toggle('is-quiet', inside > 0);
      }, { rootMargin: '-45% 0px -10% 0px' });
      chapters.forEach(function (chapter) { watcher.observe(chapter); });
    })();

    // ------------------------------------------------ delivery estimate
    // "Usually within 5 working days" becomes a date (Product Page Plan). Counts
    // working days from today, skipping weekends; the wording is a setting.
    (function deliveryEstimate() {
      var el = root.querySelector('[data-p-delivery-estimate]');
      if (!el || !el.dataset.template) return;
      var days = parseInt(el.dataset.days, 10) || 5;
      var d = new Date();
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days -= 1;
      }
      var text = d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
      el.textContent = el.dataset.template.replace('{date}', text);
      el.hidden = false;
    })();

    // ------------------------------------------------ the final close buys
    // The button at the foot of the page adds the chosen variant, the same as
    // the one at the top. Without a form it stays a link back to the buy box.
    document.querySelectorAll('[data-p-echo-buy]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        if (!form) return;
        // Safari before 16 has no requestSubmit: press the form's own button instead, which adds the light the same way.
        var submit = form.querySelector('[type="submit"]');
        if (!form.requestSubmit && !submit) return;
        event.preventDefault();
        if (form.requestSubmit) form.requestSubmit(); else submit.click();
      });
    });

    // ------------------------------------------------------ compare sizes
    // Josh, 16 Sep: "Compare sizes opens the upsell prompt, not compare sizes."
    // The link used to scroll the page, and the scroll made the floating buy
    // bar appear. Now it opens a small panel with the two bases side by side.
    (function wireSizes() {
      var open = root.querySelector('[data-p-sizes-open]');
      var dialog = root.querySelector('[data-p-sizes]');
      if (!open) return;
      open.addEventListener('click', function (event) {
        event.preventDefault();
        // The SellUp app listens in the capture phase for any <a> inside the
        // add-to-cart form, so this trigger is a <button type="button">, which
        // its selector ignores. Without dialog support, fall back to the anchor.
        if (!dialog || !dialog.showModal) {
          if (open.dataset.href) window.location.hash = open.dataset.href;
          return;
        }
        dialog.showModal();
      });
      if (!dialog) return;
      var close = dialog.querySelector('[data-p-sizes-close]');
      if (close) close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      // Each card's button picks that base in the buy box, then closes the panel.
      dialog.querySelectorAll('[data-p-sizes-choose]').forEach(function (button) {
        button.addEventListener('click', function () {
          var value = button.dataset.pSizesChoose;
          var match = Array.prototype.find.call(root.querySelectorAll('[data-p-base]'), function (el) { return el.dataset.pBase === value; });
          if (match) match.click();
          dialog.close();
        });
      });
    })();

    (function wireEnlarge() {
      var open = root.querySelector('[data-p-enlarge]');
      if (!open || !hero || typeof HTMLDialogElement === 'undefined') return;
      var dialog = document.createElement('dialog');
      dialog.className = 'p-lightbox';
      dialog.setAttribute('aria-label', 'Enlarged photograph');
      dialog.innerHTML = '<button type="button" class="p-lightbox-close" aria-label="Close">&times;</button>'
        + '<img alt="" class="p-lightbox-image">'
        + '<div class="p-lightbox-nav"><button type="button" data-p-lightbox-prev aria-label="Previous photograph">&#8592;</button>'
        + '<button type="button" data-p-lightbox-next aria-label="Next photograph">&#8594;</button></div>'
        + '<p class="p-lightbox-caption"></p>';
      document.body.appendChild(dialog);
      var img = dialog.querySelector('.p-lightbox-image'), cap = dialog.querySelector('.p-lightbox-caption');
      function sync() {
        var b = thumbs[currentShot()];
        img.src = (b && b.dataset.pFull) || hero.src;
        cap.textContent = (b && b.dataset.pCaption) || '';
      }
      open.addEventListener('click', function () { sync(); dialog.showModal(); });
      if (hero) hero.addEventListener('click', function () { if (swiped) { swiped = false; return; } open.click(); });
      dialog.querySelector('.p-lightbox-close').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      dialog.querySelector('[data-p-lightbox-prev]').addEventListener('click', function () { showShot((currentShot() - 1 + thumbs.length) % thumbs.length); sync(); });
      dialog.querySelector('[data-p-lightbox-next]').addEventListener('click', function () { showShot((currentShot() + 1) % thumbs.length); sync(); });
    })();

    function currentShot() {
      var found = thumbs.findIndex(function (b) {
        return b.getAttribute('aria-pressed') === 'true';
      });
      return found < 0 ? 0 : found;
    }

    var prev = root.querySelector('[data-p-gallery-prev]');
    var next = root.querySelector('[data-p-gallery-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        showShot((currentShot() - 1 + thumbs.length) % thumbs.length);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        showShot((currentShot() + 1) % thumbs.length);
      });
    }

    // --------------------------------------------------------- add to cart
    if (form) {
      // A page restored from the back-forward cache keeps whatever the button
      // said when we left it. Reset it whenever the page is shown again.
      var leaving = false;
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;
        // Back from the basket after an add showed this page as it was before the add, with no basket count, so a second
        // press put two lights in the basket (full audit round 2, 8 Oct 2026). Only then does it reload, for the real
        // count, stock and button; any other return from the cache resets the button as before.
        if (leaving) { window.location.reload(); return; }
        adding = false;
        syncBuy(findVariant());
      });
      form.addEventListener('submit', function (event) {
        // A browser without fetch or promises (iOS 10.2 and older) posts the form as it is: the hidden id always holds the
        // choice on screen, so the right light goes to the basket (22 Oct 2026).
        if (!window.fetch || !window.Promise) return;
        event.preventDefault();
        if (!buyButton || buyButton.disabled || adding) return;

        var variant = findVariant();
        if (!variant || !variant.available) return;

        if (errorEl) errorEl.hidden = true;
        adding = true;
        buyButton.disabled = true;
        if (buyLabel) buyLabel.textContent = 'Adding...';

        var drawer = document.querySelector('cart-drawer');
        var item = { id: variant.id, quantity: 1 };
        // Line-item properties on the form go with the light. SellUp adds properties[_sellup_id] and
        // properties[added] when a shopper arrives from one of its offers, and this request used to drop them.
        var properties = {};
        if (window.FormData && FormData.prototype.forEach) {
          new FormData(form).forEach(function (value, key) {
            var match = /^properties\[(.+)\]$/.exec(key);
            if (match && typeof value === 'string') properties[match[1]] = value;
          });
        }
        if (Object.keys(properties).length) item.properties = properties;
        var body = {
          items: [item],
        };
        // Dawn's drawer re-renders itself from these section ids.
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map(function (s) {
            return s.id;
          });
          body.sections_url = window.location.pathname;
        }

        // A reply that never comes (a weak phone signal) left the button shut on "Adding..." for good. After 20 seconds the
        // request is given up, the failure words show and the button opens again (full audit round 3, 8 Oct 2026).
        // Browsers without AbortController (Safari before 12.1) keep the old behaviour.
        var addCtl = window.AbortController ? new AbortController() : null;
        var addTimer = addCtl ? window.setTimeout(function () { addCtl.abort(); }, 20000) : null;
        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body),
          signal: addCtl ? addCtl.signal : undefined,
        })
          .then(function (response) {
            return response.json().then(function (result) {
              // A failed reply without Shopify's own status (a server error, a rate limit) is still a
              // failure, and must not send anyone to a basket their light is not in.
              if (!response.ok && !result.status) result.status = response.status;
              return result;
            });
          })
          .then(function (result) {
            if (result.status) {
              var refused = new Error(result.description || '');
              refused.fromShop = true;
              throw refused;
            }

            // THE ADD-ONS PANEL (upsell test version, 22 Oct 2026). The light is in the basket now. When the page has the
            // panel and something to offer, it opens here instead of the jump to the basket, and its Go to basket link
            // takes over the leaving. In every other case, an error inside the panel included, this carries on to the
            // basket exactly as before (Josh: "this CANNOT break and stop people ordering").
            var upsellOpen = false;
            try {
              upsellOpen = !!(window.v4Upsell && window.v4Upsell.open(result, {
                price: priceEl ? priceEl.textContent : '',
                // The panel's picture of the light: its cut-out in the finish and base just chosen (the HD Original, the
                // Gemini, the Wall light), or none. Shopify's basket gives the product's main photo whatever was chosen,
                // which shows a Heritage White buyer a black light (Josh, 20 Oct 2026: a photo must show that variant).
                image: lightShot(),
                exactImage: true,
                onLeave: function () { leaving = true; }
              }));
            } catch (upsellError) {
              upsellOpen = false;
            }
            if (upsellOpen) {
              if (buyLabel) buyLabel.textContent = 'Added';
              window.setTimeout(function () {
                syncBuy(findVariant());
              }, 2000);
              return;
            }

            if (drawer && drawer.renderContents) {
              drawer.renderContents(result);
            } else {
              // Leaving for the basket page. Put the button back first, because
              // the browser keeps this page in memory and shows it again on
              // "back" exactly as we left it (Josh, 16 Sep: "it says adding").
              if (buyLabel) buyLabel.textContent = label('add', 'Add to basket');
              leaving = true;
              window.location.href = window.routes.cart_url;
              return;
            }

            if (buyLabel) buyLabel.textContent = 'Added';
            window.setTimeout(function () {
              syncBuy(findVariant());
            }, 2000);
          })
          .catch(function (error) {
            if (errorEl) {
              // Shopify's own reason is shown as it comes. A dropped connection or an unreadable reply
              // gets these words rather than the browser's ("Load failed", "Unexpected token").
              errorEl.textContent = (error && error.fromShop && error.message) || (error && error.name === 'AbortError' ? 'This is taking longer than it should. Please look in your basket before you try again, or call 0800 032 9366.' : 'We could not add that to your basket. Please try again, or call 0800 032 9366.');
              errorEl.hidden = false;
            }
          })
          .then(function () {
            if (addTimer) window.clearTimeout(addTimer);
            // On the way to the basket the button stays shut; the Back button's pageshow opens it again.
            if (leaving) return;
            // Back to the choice now on screen, which may have changed while the light was being added.
            adding = false;
            syncBuy(findVariant(), buyLabel && buyLabel.textContent === 'Added');
            // Shutting the button while it worked threw keyboard focus to the top of the page; it goes back to the button
            // (full audit round 3, 8 Oct 2026).
            if (buyButton && !buyButton.disabled && (!document.activeElement || document.activeElement === document.body)) buyButton.focus();
          });
      });
    }

    render();
  }

  // THE STICKY BAR, for every product page with a buy form: the lights' own buy box, and the bulb and part pages,
  // whose 28 templates carry the bar but never started it because this lived inside the lights' wiring (audit,
  // 25 Sep 2026). The bar waits until the buy block has scrolled off the top of the screen, and its button glides
  // back to it (Josh, 16 Sep: it used to be a link to the page itself, so tapping it reloaded the page).
  var stickyWired = false;
  function stickyBar() {
    if (stickyWired) return;
    var bar = document.querySelector('.p-mobile-buy');
    var buy = document.querySelector('.p-buy') || document.getElementById('v4-product-form');
    if (!bar || !buy) return;
    stickyWired = true;
    // Room for the bar under the footer without :has(), which Safari reads only from 15.4.
    document.body.classList.add('has-p-bar');
    // While the bar covers the bottom of the screen, anything reached with the keyboard stops above it rather than
    // under it (launch audit, 25 Sep 2026: Safari and Firefox tabbed to buttons hidden beneath the bar).
    function show(on) {
      bar.classList.toggle('is-shown', on);
      bar.inert = !on;
      document.documentElement.classList.toggle('sr-bar-on', on);
      document.documentElement.style.scrollPaddingBottom = on && bar.offsetHeight ? (bar.offsetHeight + 16) + 'px' : '';
    }
    if (!('IntersectionObserver' in window)) show(true);
    else {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // gone above the viewport: show; visible, or still below: hide
        show(!e.isIntersecting && e.boundingClientRect.bottom < 0);
      }, { threshold: 0 }).observe(buy);
    }
    // A jump with the End or Home key can pass the whole buy block between two frames; Firefox and Safari then missed
    // the change and left the bar showing at the top or hidden at the bottom (browser and device check, 25 Sep 2026).
    // The bar also follows the scroll position itself, at most once a frame.
    var queued = false;
    function follow() {
      queued = false;
      show(buy.getBoundingClientRect().bottom < 0);
    }
    function soon() { if (!queued) { queued = true; requestAnimationFrame(follow); } }
    window.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    document.querySelectorAll('[data-p-sticky-up]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        // On a bulb or part page #p-buy is the whole section, photograph first, so the bar goes to the form with the
        // choices and the button instead (device audit, 22 Oct 2026).
        var target = document.querySelector('.p-bulb-form, .p-part-form') || document.getElementById('p-buy') || document.querySelector('.p-top') || buy;
        event.preventDefault();
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
        // Keyboard focus goes with the page, so the next Tab lands in the options just brought into view: the chosen
        // radio on a bulb or part page, the first choice button on a light's page. On bulb and part pages
        // [data-p-option] is the fieldset, which cannot take focus, so focus used to stay on this bar as it slid away
        // (purchase audit, 25 Sep 2026). If nothing takes it, the buy block itself does.
        var first = target.querySelector('input[type=radio]:checked:not([disabled])')
          || target.querySelector('button[data-p-finish], button[data-p-base], button[data-p-option], input[type=radio]:not([disabled]), button:not([disabled])');
        if (first) first.focus({ preventScroll: true });
        if (!first || document.activeElement !== first) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-v4-product]').forEach(wire);
    stickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
